import { useState } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { brand, navLinks } from "../content/navigation"
import useIsMobile from "../hooks/useIsMobile"

export default function Navbar() {
    const isMobile  = useIsMobile()
    const navigate  = useNavigate()
    const location  = useLocation()
    const [menuOpen, setMenuOpen] = useState(false)

    const handleNavClick = (id) => {
        setMenuOpen(false)
        if (location.pathname === "/") {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
        } else {
            navigate("/", { state: { scrollTo: id } })
        }
    }

    return (
        <div style={{ width: "100%", maxWidth: 1200, margin: "0 auto", padding: isMobile ? "20px 20px" : "28px 32px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Link to="/" style={{ fontSize: isMobile ? 26 : 34, fontWeight: 800, color: "#111827", letterSpacing: "-0.03em", textDecoration: "none" }}>
                    {brand.logoText}
                </Link>

                {isMobile ? (
                    <button
                        onClick={() => setMenuOpen((o) => !o)}
                        aria-label="Toggle menu"
                        style={{
                            background: "none", border: "none", cursor: "pointer",
                            padding: 8, color: "#111827",
                        }}
                    >
                        {menuOpen ? (
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        ) : (
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                <line x1="3" y1="7" x2="21" y2="7" />
                                <line x1="3" y1="12" x2="21" y2="12" />
                                <line x1="3" y1="17" x2="21" y2="17" />
                            </svg>
                        )}
                    </button>
                ) : (
                    <nav style={{ display: "flex", gap: 28, color: "#6B7280", fontSize: 17, fontWeight: 500 }}>
                        {navLinks.map((link) => (
                            <button
                                key={link.href}
                                onClick={() => handleNavClick(link.href.replace("#", ""))}
                                style={{
                                    background: "none", border: "none", cursor: "pointer",
                                    color: "#6B7280", fontSize: 17, fontWeight: 500,
                                    fontFamily: "inherit", padding: 0,
                                }}
                            >
                                {link.label}
                            </button>
                        ))}
                    </nav>
                )}
            </div>

            {isMobile && menuOpen && (
                <nav style={{
                    display: "flex", flexDirection: "column", gap: 4,
                    paddingTop: 16, borderTop: "1px solid #E5E7EB", marginTop: 16,
                }}>
                    {navLinks.map((link) => (
                        <button
                            key={link.href}
                            onClick={() => handleNavClick(link.href.replace("#", ""))}
                            style={{
                                background: "none", border: "none", cursor: "pointer",
                                color: "#374151", fontSize: 17, fontWeight: 500,
                                fontFamily: "inherit", padding: "10px 0",
                                textAlign: "left",
                            }}
                        >
                            {link.label}
                        </button>
                    ))}
                </nav>
            )}
        </div>
    )
}
